import {NgModule} from '@angular/core';
import {SecurityService} from '../../../../components/security';
import {DistributedStreamingRegistryService, StreamingModule} from '../../../../components/streaming';
import {SubscriptionStreamingService} from '../../../../components/streaming/subscription-streaming.service';
import {CandleStreamingService} from './candle-streaming.service';

@NgModule({
    imports: [
        StreamingModule
    ],
    providers: [
        {
            provide: CandleStreamingService,
            useFactory: (
                         distributedStreamingRegistryService: DistributedStreamingRegistryService,
                         securityService: SecurityService
                     ) => {
                const injector = distributedStreamingRegistryService
                    .getStreamingServiceInjector('candlesStreaming');

                return new CandleStreamingService(
                    injector.get(SubscriptionStreamingService),
                    securityService
                );
            },
            deps: [DistributedStreamingRegistryService, SecurityService]
        }
    ]
})
export class CandleStreamingModule {}
